export let PlanQuizFlow;
(function (PlanQuizFlow) {
  PlanQuizFlow["EMAIL_LINK"] = "email-link";
  PlanQuizFlow["QUIZ"] = "quiz";
})(PlanQuizFlow || (PlanQuizFlow = {}));
export let PlanQuizStep;
(function (PlanQuizStep) {
  PlanQuizStep["EMAIL_INPUT"] = "email-input";
  PlanQuizStep["QUIZ_USE_CASES"] = "quiz-use-cases";
  PlanQuizStep["QUIZ_TEAM_SIZE"] = "quiz-team-size";
  PlanQuizStep["LOADING"] = "loading";
  PlanQuizStep["RESULTS"] = "results";
})(PlanQuizStep || (PlanQuizStep = {}));
export const QUIZ_USE_CASE_MAP = {
  'get-more-leads': 'MARKETING',
  'close-more-deals': 'SALES',
  'help-customers': 'SERVICE',
  'organize-data': 'SMART_CRM'
};
const TEAM_SIZE_KEYS = ['just-me', '2-5', '6-15', '16-50', '51+'];
export const STEP_BACK_MAP = {
  [PlanQuizStep.QUIZ_USE_CASES]: PlanQuizStep.EMAIL_INPUT,
  [PlanQuizStep.QUIZ_TEAM_SIZE]: PlanQuizStep.QUIZ_USE_CASES,
  [PlanQuizStep.RESULTS]: PlanQuizStep.EMAIL_INPUT
};
export const MAX_QUIZ_CORE_SEATS = 99;
export const DEFAULT_USE_CASES = ['MARKETING', 'SALES', 'SERVICE'];
export function isGtmSeatsProduct(productApiName) {
  return productApiName.includes('gtm-seats');
}